import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    TeaserComparisonTemplate,
    comparisonTeaserData,
} from "./teaser-comparison.templates";

export default {
    title: "Website/Partial Templates/Teaser/Comparison",
    render: TeaserComparisonTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {
    args: {
        ...comparisonTeaserData,
    },
};
